module.exports = require('./lib/ObjectPath.js').ObjectPath;



//////////////////
// WEBPACK FOOTER
// ./~/objectpath/index.js
// module id = 531
// module chunks = 1